<template lang="pug">
  div(
  v-if="id"
  ).branch-tariffs
    div.table-choose-panel
      div.toolbar-table
        e-select-list(
        v-model="operationType"
        :options="[{id: 'branchs', name: 'История изменений'}]"
        )
        div.toolbar.toolbar--modal
          div.line
            div.actions-panel
              span(
              v-if="model && model.is_closed"
              ) Тариф закрыт
              e-button-add(
              v-else
              @click="addRow()"
              )

    div.tariffs
      e-table-editable(
      ref="editTable"
      :attributes="attr"
      :dataUrl="dataUrl"
      :postUrl="postUrl"
      :patchUrl="() => null"
      :deleteUrl="() => null"
      :tableInOnlineMode="tableInOnlineMode"
      :tableHeight="'250'"
      :tableHeightRight="'250'"
      :fewRowsCount="2"
      :defaultColumnWidth="120"
      :onToggleEditable="onToggleEditable"
      :autoSaveAfterChange="false"
      :afterValidate="afterValidate"
      :exitFromEditModeAfterSave="true"
      )
        div(slot="buttons" slot-scope="props")
          button(
          v-if="!props.model.id && props.acceptEdit"
          @click.stop.prevent="onToggleEditable(props.model)"
          ).row-edit
          button(
          v-if="!props.model.id && props.acceptDelete"
          @click.stop.prevent="getTable().deleteRow(props.model)"
          ).row-delete
</template>

<script>
  import {billing} from "../../../api/api-endpoints"
  import {billingOffline} from "../../../api/api-offline-endpoints"
  import {dateToUnixTime} from "../../../filters/time"

  export default {
    props: {
      id: null,
      model: null
    },
    name: "branch-tariffs",
    data () {
      return {
        operationType: 'branchs'
      }
    },
    computed: {
      tableInOnlineMode () {
        return this.id
      },
      dataUrl () {
        if (this.tableInOnlineMode) {
          return billing.branchTariffs(
            this.id,
            {
              query: {
                'per-page': -1
              }
            }
          )
        }

        return billingOffline.branchTariffsTable(this.$route.name)
      },
      attr () {
        return {
          start_date: {
            label: "Начало действия",
            calendar: {},
            required: true,
            placeholder: ' ',
            validationRulePattern: '(\\.*)',
          },
          end_date: {
            label: "Окончание действия",
            calendar: {},
            placeholder: ' ',
            validationRulePattern: '(\\.*)',
          },
          value: {
            label: "Значение",
            required: true
          }
        }
      }
    },
    methods: {
      afterValidate (ctx, model, errors) {
        if (model.start_date && model.end_date) {
          const unixSD = dateToUnixTime(model.start_date)
          const unixED = dateToUnixTime(model.end_date)
          if (unixED <= unixSD) {
            errors.end_date = 'Дата окончания должна быть больше даты начала'
          }
        }
        return errors
      },
      onToggleEditable (model, ...args) {
        if (model.id) {
          return
        }
        this.getTable().toggleEditable(model, ...args)
      },
      getTable () {
        return this.$refs.editTable
      },
      postUrl () {
        return billing.branchTariffCreate(this.id)
      },
      addRow () {
        const Model = () => ({
          start_date: '',
          end_date: '',
          value: ''
        })
        this.$refs.editTable.createRow(new Model())
      }
    }
  }
</script>
